import { BugsnagStatic } from '@bugsnag/js';
import angular, { IWindowService } from 'angular';

export class BugsnagService {
  static $inject = ['$window'];

  private get instance() {
    return this.$window.Bugsnag as BugsnagStatic;
  }

  notify = this.instance.notify;

  constructor(private $window: IWindowService) {}

  start() {
    if (this.instance && this.$window.ENV && this.$window?.CONFIG?.bugsnag?.key) {
      this.instance.start({
        apiKey: this.$window.CONFIG.bugsnag.key,
        releaseStage: this.$window.ENV,
        appVersion: this.$window.VERSION,
      });
    }
  }
}

export const BugsnagServiceModule = angular
  .module('acme.common.service.bugsnag', [])
  .service('BugsnagService', BugsnagService).name;
